import React from 'react';

import { ThemeProvider } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import { AutoSizer } from 'react-virtualized';

import { Campaign } from '@vromo/models';
import Marker from '@vromo/tracking-link/WeDispatch/Marker';

import {
    ActionButton,
    ActionButtons,
    Avatar,
    Device,
    Driver,
    Footer,
    Header,
    ImageWrapper,
    Map,
    Mappy,
    MarkerWrapper,
    Screen
} from './styledComponents';

const LOCALE_CALL = 'Call';
const LOCALE_NAME = 'John Smith';
const LOCALE_SMS = 'SMS';

export default observer<{ campaign: Campaign }>(function TrackingLinkPreview({ campaign }) {
    const height = 967;
    const width = 495;

    const verticalOffset = 150;
    const horizontalOffset = 60;

    const scale = 0.6;

    const theme = {
        accent: campaign.theme?.enabled ? campaign.theme.accent : '#189BF3',
        background: campaign.theme?.enabled ? campaign.theme.background : '#FFFFFF',
        height: height * scale,
        paddingHorizontal: horizontalOffset * scale,
        paddingVertical: verticalOffset * scale,
        width: width * scale
    };

    const { theme: campaignTheme, logo } = campaign;
    const { icon, accent, enabled } = campaignTheme || {};

    return (
        <ThemeProvider theme={theme}>
            <Device>
                <Screen>
                    {logo?.url && (
                        <Header>
                            <img src={logo.url} style={{ height: 30 }} />
                        </Header>
                    )}
                    <Map>
                        <AutoSizer>
                            {({ width, height }) => <Mappy width={width} height={height} />}
                        </AutoSizer>
                        <ImageWrapper>
                            <img
                                src={
                                    enabled && icon?.url
                                        ? icon.url
                                        : require('./assets/defaultMapIcon.png')
                                }
                                style={{
                                    maxWidth: 54 * 0.5,
                                    maxHeight: 54 * 0.5,
                                    transform: 'rotate(28deg)'
                                }}
                            />
                        </ImageWrapper>
                        <MarkerWrapper>
                            <Marker color={enabled ? accent : '#189BF3'} />
                        </MarkerWrapper>
                    </Map>
                    <Footer>
                        <Avatar />
                        <div>
                            <Driver>{LOCALE_NAME}</Driver>
                            <ActionButtons>
                                <ActionButton>{LOCALE_CALL}</ActionButton>
                                <ActionButton>{LOCALE_SMS}</ActionButton>
                            </ActionButtons>
                        </div>
                    </Footer>
                </Screen>
            </Device>
        </ThemeProvider>
    );
});
